module.exports = __webpack_public_path__ + "img/icon-数学@2x.86655897.png";